/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletCryptoPreviewRouteImport } from './routes/wallet-crypto-preview'
import { Route as SettingsPreviewRouteImport } from './routes/settings-preview'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PortfolioPreviewRouteImport } from './routes/portfolio-preview'
import { Route as MiniAppPreviewRouteImport } from './routes/mini-app-preview'
import { Route as MarketsPreviewRouteImport } from './routes/markets-preview'
import { Route as KitchenSinkRouteImport } from './routes/kitchen-sink'
import { Route as DetailPreviewRouteImport } from './routes/detail-preview'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as CompositesRouteImport } from './routes/composites'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthLaunchRouteImport } from './routes/auth.launch'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppWatchlistRouteImport } from './routes/_app/watchlist'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppRankRouteImport } from './routes/_app/rank'
import { Route as AppPortfolioRouteImport } from './routes/_app/portfolio'
import { Route as AppExploreRouteImport } from './routes/_app/explore'
import { Route as AppWalletIndexRouteImport } from './routes/_app/wallet.index'
import { Route as AppWalletCryptoRouteImport } from './routes/_app/wallet.crypto'
import { Route as AppSettingsTermsRouteImport } from './routes/_app/settings_.terms'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings_.security'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings_.privacy'
import { Route as AppSettingsHelpRouteImport } from './routes/_app/settings_.help'
import { Route as AppSettingsEditRouteImport } from './routes/_app/settings_.edit'
import { Route as AppSettingsDeleteRouteImport } from './routes/_app/settings_.delete'
import { Route as AppSettingsActivityRouteImport } from './routes/_app/settings_.activity'
import { Route as AppRankLeagueIdRouteImport } from './routes/_app/rank_.$leagueId'
import { Route as AppMarketsIdRouteImport } from './routes/_app/markets.$id'
import { Route as AppExploreIdRouteImport } from './routes/_app/explore_.$id'
import { Route as AppRankJoinCodeRouteImport } from './routes/_app/rank_.join.$code'
import { Route as AppRankLeagueIdSettingsRouteImport } from './routes/_app/rank_.$leagueId_.settings'
import { Route as AppRankLeagueIdMembersRouteImport } from './routes/_app/rank_.$leagueId_.members'

const WalletCryptoPreviewRoute = WalletCryptoPreviewRouteImport.update({
  id: '/wallet-crypto-preview',
  path: '/wallet-crypto-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreviewRoute = SettingsPreviewRouteImport.update({
  id: '/settings-preview',
  path: '/settings-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioPreviewRoute = PortfolioPreviewRouteImport.update({
  id: '/portfolio-preview',
  path: '/portfolio-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const MiniAppPreviewRoute = MiniAppPreviewRouteImport.update({
  id: '/mini-app-preview',
  path: '/mini-app-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketsPreviewRoute = MarketsPreviewRouteImport.update({
  id: '/markets-preview',
  path: '/markets-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const KitchenSinkRoute = KitchenSinkRouteImport.update({
  id: '/kitchen-sink',
  path: '/kitchen-sink',
  getParentRoute: () => rootRouteImport,
} as any)
const DetailPreviewRoute = DetailPreviewRouteImport.update({
  id: '/detail-preview',
  path: '/detail-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const CompositesRoute = CompositesRouteImport.update({
  id: '/composites',
  path: '/composites',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWatchlistRoute = AppWatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRankRoute = AppRankRouteImport.update({
  id: '/rank',
  path: '/rank',
  getParentRoute: () => AppRoute,
} as any)
const AppPortfolioRoute = AppPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AppRoute,
} as any)
const AppExploreRoute = AppExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AppRoute,
} as any)
const AppWalletIndexRoute = AppWalletIndexRouteImport.update({
  id: '/wallet/',
  path: '/wallet/',
  getParentRoute: () => AppRoute,
} as any)
const AppWalletCryptoRoute = AppWalletCryptoRouteImport.update({
  id: '/wallet/crypto',
  path: '/wallet/crypto',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTermsRoute = AppSettingsTermsRouteImport.update({
  id: '/settings_/terms',
  path: '/settings/terms',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/settings_/security',
  path: '/settings/security',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/settings_/privacy',
  path: '/settings/privacy',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsHelpRoute = AppSettingsHelpRouteImport.update({
  id: '/settings_/help',
  path: '/settings/help',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsEditRoute = AppSettingsEditRouteImport.update({
  id: '/settings_/edit',
  path: '/settings/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDeleteRoute = AppSettingsDeleteRouteImport.update({
  id: '/settings_/delete',
  path: '/settings/delete',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsActivityRoute = AppSettingsActivityRouteImport.update({
  id: '/settings_/activity',
  path: '/settings/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppRankLeagueIdRoute = AppRankLeagueIdRouteImport.update({
  id: '/rank_/$leagueId',
  path: '/rank/$leagueId',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketsIdRoute = AppMarketsIdRouteImport.update({
  id: '/markets/$id',
  path: '/markets/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppExploreIdRoute = AppExploreIdRouteImport.update({
  id: '/explore_/$id',
  path: '/explore/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppRankJoinCodeRoute = AppRankJoinCodeRouteImport.update({
  id: '/rank_/join/$code',
  path: '/rank/join/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppRankLeagueIdSettingsRoute = AppRankLeagueIdSettingsRouteImport.update({
  id: '/rank_/$leagueId_/settings',
  path: '/rank/$leagueId/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRankLeagueIdMembersRoute = AppRankLeagueIdMembersRouteImport.update({
  id: '/rank_/$leagueId_/members',
  path: '/rank/$leagueId/members',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/composites': typeof CompositesRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/detail-preview': typeof DetailPreviewRoute
  '/kitchen-sink': typeof KitchenSinkRoute
  '/markets-preview': typeof MarketsPreviewRoute
  '/mini-app-preview': typeof MiniAppPreviewRoute
  '/portfolio-preview': typeof PortfolioPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings-preview': typeof SettingsPreviewRoute
  '/wallet-crypto-preview': typeof WalletCryptoPreviewRoute
  '/explore': typeof AppExploreRoute
  '/portfolio': typeof AppPortfolioRoute
  '/rank': typeof AppRankRoute
  '/settings': typeof AppSettingsRoute
  '/watchlist': typeof AppWatchlistRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/explore/$id': typeof AppExploreIdRoute
  '/markets/$id': typeof AppMarketsIdRoute
  '/rank/$leagueId': typeof AppRankLeagueIdRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/delete': typeof AppSettingsDeleteRoute
  '/settings/edit': typeof AppSettingsEditRoute
  '/settings/help': typeof AppSettingsHelpRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/wallet/crypto': typeof AppWalletCryptoRoute
  '/wallet/': typeof AppWalletIndexRoute
  '/rank/$leagueId/members': typeof AppRankLeagueIdMembersRoute
  '/rank/$leagueId/settings': typeof AppRankLeagueIdSettingsRoute
  '/rank/join/$code': typeof AppRankJoinCodeRoute
}
export interface FileRoutesByTo {
  '/composites': typeof CompositesRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/detail-preview': typeof DetailPreviewRoute
  '/kitchen-sink': typeof KitchenSinkRoute
  '/markets-preview': typeof MarketsPreviewRoute
  '/mini-app-preview': typeof MiniAppPreviewRoute
  '/portfolio-preview': typeof PortfolioPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings-preview': typeof SettingsPreviewRoute
  '/wallet-crypto-preview': typeof WalletCryptoPreviewRoute
  '/explore': typeof AppExploreRoute
  '/portfolio': typeof AppPortfolioRoute
  '/rank': typeof AppRankRoute
  '/settings': typeof AppSettingsRoute
  '/watchlist': typeof AppWatchlistRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/explore/$id': typeof AppExploreIdRoute
  '/markets/$id': typeof AppMarketsIdRoute
  '/rank/$leagueId': typeof AppRankLeagueIdRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/delete': typeof AppSettingsDeleteRoute
  '/settings/edit': typeof AppSettingsEditRoute
  '/settings/help': typeof AppSettingsHelpRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/terms': typeof AppSettingsTermsRoute
  '/wallet/crypto': typeof AppWalletCryptoRoute
  '/wallet': typeof AppWalletIndexRoute
  '/rank/$leagueId/members': typeof AppRankLeagueIdMembersRoute
  '/rank/$leagueId/settings': typeof AppRankLeagueIdSettingsRoute
  '/rank/join/$code': typeof AppRankJoinCodeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/composites': typeof CompositesRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/detail-preview': typeof DetailPreviewRoute
  '/kitchen-sink': typeof KitchenSinkRoute
  '/markets-preview': typeof MarketsPreviewRoute
  '/mini-app-preview': typeof MiniAppPreviewRoute
  '/portfolio-preview': typeof PortfolioPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings-preview': typeof SettingsPreviewRoute
  '/wallet-crypto-preview': typeof WalletCryptoPreviewRoute
  '/_app/explore': typeof AppExploreRoute
  '/_app/portfolio': typeof AppPortfolioRoute
  '/_app/rank': typeof AppRankRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/watchlist': typeof AppWatchlistRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/explore_/$id': typeof AppExploreIdRoute
  '/_app/markets/$id': typeof AppMarketsIdRoute
  '/_app/rank_/$leagueId': typeof AppRankLeagueIdRoute
  '/_app/settings_/activity': typeof AppSettingsActivityRoute
  '/_app/settings_/delete': typeof AppSettingsDeleteRoute
  '/_app/settings_/edit': typeof AppSettingsEditRoute
  '/_app/settings_/help': typeof AppSettingsHelpRoute
  '/_app/settings_/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings_/security': typeof AppSettingsSecurityRoute
  '/_app/settings_/terms': typeof AppSettingsTermsRoute
  '/_app/wallet/crypto': typeof AppWalletCryptoRoute
  '/_app/wallet/': typeof AppWalletIndexRoute
  '/_app/rank_/$leagueId_/members': typeof AppRankLeagueIdMembersRoute
  '/_app/rank_/$leagueId_/settings': typeof AppRankLeagueIdSettingsRoute
  '/_app/rank_/join/$code': typeof AppRankJoinCodeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/composites'
    | '/confirm-email'
    | '/detail-preview'
    | '/kitchen-sink'
    | '/markets-preview'
    | '/mini-app-preview'
    | '/portfolio-preview'
    | '/reset-password'
    | '/settings-preview'
    | '/wallet-crypto-preview'
    | '/explore'
    | '/portfolio'
    | '/rank'
    | '/settings'
    | '/watchlist'
    | '/auth/callback'
    | '/auth/launch'
    | '/explore/$id'
    | '/markets/$id'
    | '/rank/$leagueId'
    | '/settings/activity'
    | '/settings/delete'
    | '/settings/edit'
    | '/settings/help'
    | '/settings/privacy'
    | '/settings/security'
    | '/settings/terms'
    | '/wallet/crypto'
    | '/wallet/'
    | '/rank/$leagueId/members'
    | '/rank/$leagueId/settings'
    | '/rank/join/$code'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/composites'
    | '/confirm-email'
    | '/detail-preview'
    | '/kitchen-sink'
    | '/markets-preview'
    | '/mini-app-preview'
    | '/portfolio-preview'
    | '/reset-password'
    | '/settings-preview'
    | '/wallet-crypto-preview'
    | '/explore'
    | '/portfolio'
    | '/rank'
    | '/settings'
    | '/watchlist'
    | '/auth/callback'
    | '/auth/launch'
    | '/'
    | '/explore/$id'
    | '/markets/$id'
    | '/rank/$leagueId'
    | '/settings/activity'
    | '/settings/delete'
    | '/settings/edit'
    | '/settings/help'
    | '/settings/privacy'
    | '/settings/security'
    | '/settings/terms'
    | '/wallet/crypto'
    | '/wallet'
    | '/rank/$leagueId/members'
    | '/rank/$leagueId/settings'
    | '/rank/join/$code'
  id:
    | '__root__'
    | '/_app'
    | '/composites'
    | '/confirm-email'
    | '/detail-preview'
    | '/kitchen-sink'
    | '/markets-preview'
    | '/mini-app-preview'
    | '/portfolio-preview'
    | '/reset-password'
    | '/settings-preview'
    | '/wallet-crypto-preview'
    | '/_app/explore'
    | '/_app/portfolio'
    | '/_app/rank'
    | '/_app/settings'
    | '/_app/watchlist'
    | '/auth/callback'
    | '/auth/launch'
    | '/_app/'
    | '/_app/explore_/$id'
    | '/_app/markets/$id'
    | '/_app/rank_/$leagueId'
    | '/_app/settings_/activity'
    | '/_app/settings_/delete'
    | '/_app/settings_/edit'
    | '/_app/settings_/help'
    | '/_app/settings_/privacy'
    | '/_app/settings_/security'
    | '/_app/settings_/terms'
    | '/_app/wallet/crypto'
    | '/_app/wallet/'
    | '/_app/rank_/$leagueId_/members'
    | '/_app/rank_/$leagueId_/settings'
    | '/_app/rank_/join/$code'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  CompositesRoute: typeof CompositesRoute
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  DetailPreviewRoute: typeof DetailPreviewRoute
  KitchenSinkRoute: typeof KitchenSinkRoute
  MarketsPreviewRoute: typeof MarketsPreviewRoute
  MiniAppPreviewRoute: typeof MiniAppPreviewRoute
  PortfolioPreviewRoute: typeof PortfolioPreviewRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsPreviewRoute: typeof SettingsPreviewRoute
  WalletCryptoPreviewRoute: typeof WalletCryptoPreviewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet-crypto-preview': {
      id: '/wallet-crypto-preview'
      path: '/wallet-crypto-preview'
      fullPath: '/wallet-crypto-preview'
      preLoaderRoute: typeof WalletCryptoPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings-preview': {
      id: '/settings-preview'
      path: '/settings-preview'
      fullPath: '/settings-preview'
      preLoaderRoute: typeof SettingsPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio-preview': {
      id: '/portfolio-preview'
      path: '/portfolio-preview'
      fullPath: '/portfolio-preview'
      preLoaderRoute: typeof PortfolioPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mini-app-preview': {
      id: '/mini-app-preview'
      path: '/mini-app-preview'
      fullPath: '/mini-app-preview'
      preLoaderRoute: typeof MiniAppPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/markets-preview': {
      id: '/markets-preview'
      path: '/markets-preview'
      fullPath: '/markets-preview'
      preLoaderRoute: typeof MarketsPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kitchen-sink': {
      id: '/kitchen-sink'
      path: '/kitchen-sink'
      fullPath: '/kitchen-sink'
      preLoaderRoute: typeof KitchenSinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/detail-preview': {
      id: '/detail-preview'
      path: '/detail-preview'
      fullPath: '/detail-preview'
      preLoaderRoute: typeof DetailPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/composites': {
      id: '/composites'
      path: '/composites'
      fullPath: '/composites'
      preLoaderRoute: typeof CompositesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/watchlist': {
      id: '/_app/watchlist'
      path: '/watchlist'
      fullPath: '/watchlist'
      preLoaderRoute: typeof AppWatchlistRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rank': {
      id: '/_app/rank'
      path: '/rank'
      fullPath: '/rank'
      preLoaderRoute: typeof AppRankRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/portfolio': {
      id: '/_app/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof AppPortfolioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore': {
      id: '/_app/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AppExploreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet/': {
      id: '/_app/wallet/'
      path: '/wallet'
      fullPath: '/wallet/'
      preLoaderRoute: typeof AppWalletIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet/crypto': {
      id: '/_app/wallet/crypto'
      path: '/wallet/crypto'
      fullPath: '/wallet/crypto'
      preLoaderRoute: typeof AppWalletCryptoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/terms': {
      id: '/_app/settings_/terms'
      path: '/settings/terms'
      fullPath: '/settings/terms'
      preLoaderRoute: typeof AppSettingsTermsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/security': {
      id: '/_app/settings_/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/privacy': {
      id: '/_app/settings_/privacy'
      path: '/settings/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/help': {
      id: '/_app/settings_/help'
      path: '/settings/help'
      fullPath: '/settings/help'
      preLoaderRoute: typeof AppSettingsHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/edit': {
      id: '/_app/settings_/edit'
      path: '/settings/edit'
      fullPath: '/settings/edit'
      preLoaderRoute: typeof AppSettingsEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/delete': {
      id: '/_app/settings_/delete'
      path: '/settings/delete'
      fullPath: '/settings/delete'
      preLoaderRoute: typeof AppSettingsDeleteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/activity': {
      id: '/_app/settings_/activity'
      path: '/settings/activity'
      fullPath: '/settings/activity'
      preLoaderRoute: typeof AppSettingsActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rank_/$leagueId': {
      id: '/_app/rank_/$leagueId'
      path: '/rank/$leagueId'
      fullPath: '/rank/$leagueId'
      preLoaderRoute: typeof AppRankLeagueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/markets/$id': {
      id: '/_app/markets/$id'
      path: '/markets/$id'
      fullPath: '/markets/$id'
      preLoaderRoute: typeof AppMarketsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/explore_/$id': {
      id: '/_app/explore_/$id'
      path: '/explore/$id'
      fullPath: '/explore/$id'
      preLoaderRoute: typeof AppExploreIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rank_/join/$code': {
      id: '/_app/rank_/join/$code'
      path: '/rank/join/$code'
      fullPath: '/rank/join/$code'
      preLoaderRoute: typeof AppRankJoinCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rank_/$leagueId_/settings': {
      id: '/_app/rank_/$leagueId_/settings'
      path: '/rank/$leagueId/settings'
      fullPath: '/rank/$leagueId/settings'
      preLoaderRoute: typeof AppRankLeagueIdSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rank_/$leagueId_/members': {
      id: '/_app/rank_/$leagueId_/members'
      path: '/rank/$leagueId/members'
      fullPath: '/rank/$leagueId/members'
      preLoaderRoute: typeof AppRankLeagueIdMembersRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppExploreRoute: typeof AppExploreRoute
  AppPortfolioRoute: typeof AppPortfolioRoute
  AppRankRoute: typeof AppRankRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppWatchlistRoute: typeof AppWatchlistRoute
  AppIndexRoute: typeof AppIndexRoute
  AppExploreIdRoute: typeof AppExploreIdRoute
  AppMarketsIdRoute: typeof AppMarketsIdRoute
  AppRankLeagueIdRoute: typeof AppRankLeagueIdRoute
  AppSettingsActivityRoute: typeof AppSettingsActivityRoute
  AppSettingsDeleteRoute: typeof AppSettingsDeleteRoute
  AppSettingsEditRoute: typeof AppSettingsEditRoute
  AppSettingsHelpRoute: typeof AppSettingsHelpRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTermsRoute: typeof AppSettingsTermsRoute
  AppWalletCryptoRoute: typeof AppWalletCryptoRoute
  AppWalletIndexRoute: typeof AppWalletIndexRoute
  AppRankLeagueIdMembersRoute: typeof AppRankLeagueIdMembersRoute
  AppRankLeagueIdSettingsRoute: typeof AppRankLeagueIdSettingsRoute
  AppRankJoinCodeRoute: typeof AppRankJoinCodeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppExploreRoute: AppExploreRoute,
  AppPortfolioRoute: AppPortfolioRoute,
  AppRankRoute: AppRankRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppWatchlistRoute: AppWatchlistRoute,
  AppIndexRoute: AppIndexRoute,
  AppExploreIdRoute: AppExploreIdRoute,
  AppMarketsIdRoute: AppMarketsIdRoute,
  AppRankLeagueIdRoute: AppRankLeagueIdRoute,
  AppSettingsActivityRoute: AppSettingsActivityRoute,
  AppSettingsDeleteRoute: AppSettingsDeleteRoute,
  AppSettingsEditRoute: AppSettingsEditRoute,
  AppSettingsHelpRoute: AppSettingsHelpRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTermsRoute: AppSettingsTermsRoute,
  AppWalletCryptoRoute: AppWalletCryptoRoute,
  AppWalletIndexRoute: AppWalletIndexRoute,
  AppRankLeagueIdMembersRoute: AppRankLeagueIdMembersRoute,
  AppRankLeagueIdSettingsRoute: AppRankLeagueIdSettingsRoute,
  AppRankJoinCodeRoute: AppRankJoinCodeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  CompositesRoute: CompositesRoute,
  ConfirmEmailRoute: ConfirmEmailRoute,
  DetailPreviewRoute: DetailPreviewRoute,
  KitchenSinkRoute: KitchenSinkRoute,
  MarketsPreviewRoute: MarketsPreviewRoute,
  MiniAppPreviewRoute: MiniAppPreviewRoute,
  PortfolioPreviewRoute: PortfolioPreviewRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsPreviewRoute: SettingsPreviewRoute,
  WalletCryptoPreviewRoute: WalletCryptoPreviewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
